import { Component, OnInit } from '@angular/core';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SharedService } from '../shared/shared.service';
import { TDUModel } from '../shared/models/shared-models';

@Component({
  templateUrl: './advanced-search-component.html',
  styleUrls: ['./check-availability.component.css']
})
export class AdvancedSearchComponent implements OnInit {
  public duns: string;
  public esid: any;
  public selectedTdu: TDUModel;
  public error_message: string;
  public hasError: boolean;
  public firstLoad: boolean;
  public enableCheckAvailablity: boolean;
  public esidTooltip: string = "Your ESI ID Number, or Electric Service Identifier, is a number that is unique to your property address. Pronounced “Easy I.D.” it’s also known as an ESIID, ESI ID or ESI-ID.";
	public acceptNewEnrollments = true;

	public acceptCenterPoint = true;
	public acceptOncor  = true;
	public acceptAEPNorth = true;
	public acceptAEPCentral = true;
	public acceptTnmp = true;

	public isTduEnrollmentBlocked = false;
  constructor(private router: Router, private sharedService: SharedService) {
    this.enableCheckAvailablity = false;
    this.hasError = true;
    this.firstLoad = true;
  }

  ngOnInit() {
	  this.sharedService.getConfigConst()
		  .then(response => {
			  if (response.status === 'success') {
				  this.acceptNewEnrollments = response.results[0]['acceptNewEnrollments'];
				  this.acceptCenterPoint = response.results[0]['acceptCenterPoint'];
				  this.acceptOncor = response.results[0]['acceptOncor'];
				  this.acceptAEPNorth = response.results[0]['acceptAEPNorth'];
				  this.acceptAEPCentral = response.results[0]['acceptCenterAEPCentral'];
				  this.acceptTnmp = response.results[0]['acceptTnmp'];
			  }
		  });
  }

  getTDUs() {
    this.error_message = "";
    this.hasError = false;

    this.sharedService.setSwitchHoldIndicator(false);
    this.router.navigate(['./enroll/esiid/' + this.esid]);
  }

  showAddressSearch() {
    this.router.navigate(['./enroll']);
  }

  validateESID(event) {
    this.firstLoad = false;
    this.hasError = false;
    if (this.esid.length === 0) {
      this.hasError = true;
      this.error_message = "Invalid Esiid"
    }
    if (isNaN(this.esid)) {
      this.hasError = true;
      this.error_message = "Invalid Esiid"
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/check-availability/advanced-search.component.ts